<template>
  <div class="div404">
    <div class="header_div">
      <div class="logo_404">
        <img src="../assets/logo.svg" >
      </div>
      <div class="ret_div" @click="comeBacke">《 返回首页</div>
    </div>
    <p class="msg1">此功能正在紧张开发中...</p>
    <p class="msg2">敬请期待!</p>
    <div class="img404"></div>

  </div>
</template>
<script>
export default {
  methods: {
    comeBacke () {
      this.$router.push('/')
    }
  }
}
</script>
<style>
  .div404{
     height: 100%;
    overflow: hidden;
  }
  .logo_404{
    width: 21.04vw;
    height: 10.47vh;
    margin-left: 6.77vw;
    margin-top: 5.13vh;
    float: left;
  }
  .logo_404>img{
    width: 100%;
    height: 100%;

  }
  .img404{
    background-image: url("../assets/404.png");
    width: 25vw;
    height: 48.357vh;
    background-size: 100%;
    margin: 0 auto;
    background-repeat: no-repeat;
  }
  .msg1{
    font-size: 2.187vw;
    line-height: 4.312vh;
    text-align: center;
    /*margin-top: 12.525vh;*/
    margin-top: 8.525vh;
    margin-bottom: 0;
  }
  .msg2{
     font-size: 2.5vw;
    line-height: 4.928vh;
    color: #2aa3ff;
    text-align: center;
    margin-top: 4.517vh;
    margin-bottom: 7.7vh;
  }
  .header_div{
    overflow: hidden;
  }
  .ret_div{
    float: right;
    margin-right: 7.03vw;
    margin-top: 9.03vh;
    cursor: pointer;
    /* color:#0088f0; */
  }

</style>



// WEBPACK FOOTER //
// src/components/404.vue